var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRatingL(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.877 5.984c-.106-.444-.531-.887-1.063-.887l-3.932-.554L9.075.776C8.862.332 8.437 0 8.012 0c-.532 0-.957.332-1.17.776L5.037 4.543l-3.933.554c-.532.111-.85.443-1.063.887-.106.443 0 .997.319 1.33l2.87 2.88-.638 4.211c-.106.554.106.997.531 1.33.425.332.957.332 1.382.11l3.614-1.994 3.614 1.994c.213.111.425.111.638.111.212 0 .531-.11.744-.221.425-.333.637-.776.531-1.33l-.638-4.1 2.87-2.88c.107-.444.213-.887 0-1.441z",
    fill: "#F2B718"
  })));
}
export default SvgRatingL;